import {turretVoteSubmitAddress, turretVoteGetVoterInfo} from "../apiConn.js"
import { useLocation } from 'react-router-dom';
import { useState, useEffect} from 'react';
import {VerifyButton} from './PurchasePage.js'

export default function AddressFormPage(props) {

    const [twitchAccessToken, setTwitchAccessToken] = useState(null)
    const [didClickVerify, setDidClickVerify] = useState(false)
    const [submitSuccess, setSubmitSuccess] = useState(false)
    const [submitError, setSubmitError] = useState(false)
    const [voterInfo, setVoterInfo] = useState(null);

    const location = useLocation();
	  const locPath = location.hash.split("#").pop()
	  const params = locPath.split("&")
	  const paramDict = {}

	params.forEach(param => {
	    var p = param.split("=")
	    paramDict[p[0]] = p[1]
	  })


	console.log("location",location)


	useEffect(() => {

    

	    if (paramDict.access_token) {
	      setTwitchAccessToken(paramDict.access_token)
	    } else {
	      // console.log("set token",window.localStorage.getItem('twitchAccessToken'))
	      setTwitchAccessToken(window.localStorage.getItem('twitchAccessToken'));
	    }
	    
	  }, []);



    useEffect(() => {
      console.log("accesstoken",twitchAccessToken)
      if (!twitchAccessToken) {
        return
      }
  
      window.localStorage.setItem('twitchAccessToken', twitchAccessToken);
  
      if (twitchAccessToken) {
        turretVoteGetVoterInfo(twitchAccessToken)
          .then(res => {
            console.log('res',res)
            setVoterInfo(res)
          })
        }
    }, [twitchAccessToken]);


    function onVerify(event) {
      setDidClickVerify(true)
    }
  
    function onSubmit(event) {
      event.preventDefault();
  
      console.log("submit", event)
  
      const personName = document.getElementById("a-name").value
      const addressLine1 = document.getElementById("a-line1").value
      const addressLine2 = document.getElementById("a-line2").value
      const city = document.getElementById("a-city").value
      const state = document.getElementById("a-state").value
      const zipcode = document.getElementById("a-zipcode").value
      const country = document.getElementById("a-country").value
      const phone = document.getElementById("a-phone").value
  
  
      return turretVoteSubmitAddress(twitchAccessToken, personName, addressLine1, addressLine2, city, state, zipcode, country, phone)
      .then(res => {
        console.log(res)
        if (res.success) {
          document.getElementById("a-name").value = ""
          document.getElementById("a-line1").value = ""
          document.getElementById("a-line2").value = ""
          document.getElementById("a-city").value = ""
          document.getElementById("a-state").value = ""
          document.getElementById("a-zipcode").value = ""
          document.getElementById("a-country").value = ""
          document.getElementById("a-phone").value = ""
          setSubmitSuccess(true)
        } else {
          setSubmitSuccess(false)
          setSubmitError(true)
        }
      })
      
      
    }
  
    return (
      <div className="container mt-5">
        <h2>Treat Bot Winner Address Form</h2>
        <form onSubmit={onSubmit}>
          <div class="input-group mb-3">
            <span class="input-group-text">Name</span>
            <input id="a-name" type="text" class="form-control" placeholder="" aria-label="" aria-describedby="basic-addon1"></input>
          </div>
          <div class="input-group mb-3">
            <span class="input-group-text">Address Line 1</span>
            <input id="a-line1" type="text" class="form-control" placeholder="" aria-label="" aria-describedby="basic-addon1"></input>
          </div>
          <div class="input-group mb-3">
            <span class="input-group-text">Address Line 2</span>
            <input id="a-line2" type="text" class="form-control" placeholder="" aria-label="" aria-describedby="basic-addon1"></input>
          </div>
          <div class="input-group mb-3">
            <span class="input-group-text">City</span>
            <input id="a-city" type="text" class="form-control" placeholder="" aria-label="" aria-describedby="basic-addon1"></input>
          </div>
          <div class="input-group mb-3">
            <span class="input-group-text">State/Province</span>
            <input id="a-state" type="text" class="form-control" placeholder="" aria-label="" aria-describedby="basic-addon1"></input>
          </div>
          <div class="input-group mb-3">
            <span class="input-group-text">Zipcode</span>
            <input id="a-zipcode" type="text" class="form-control" placeholder="" aria-label="" aria-describedby="basic-addon1"></input>
          </div>
          <div class="input-group mb-3">
            <span class="input-group-text">Country</span>
            <input id="a-country" type="text" class="form-control" placeholder="" aria-label="" aria-describedby="basic-addon1"></input>
          </div>
          <div class="input-group mb-3">
            <span class="input-group-text">Phone Number</span>
            <input id="a-phone" type="text" class="form-control" placeholder="Required for Canada by UPS/FedEx" aria-label="" aria-describedby="basic-addon1"></input>
          </div>
          
          {twitchAccessToken && voterInfo &&  <button type="submit" className="btn btn-primary">Submit</button>}
          
        </form>

        {  ((!twitchAccessToken || !voterInfo) && !didClickVerify) &&
			        <div className="row justify-content-center mb-4">
			              <div className="col-6">
			                <div className="row">
			                  <button className="btn btn-purple" onClick={onVerify} >
			                      Verify Twitch Account to Claim
			                  </button>
			                  </div>
			              </div>
			            </div>

			      }
        {(didClickVerify && (!twitchAccessToken || !voterInfo)) && <VerifyButton url={props.url + "winner"}/>}

        {submitSuccess && <div className="row justify-content-center mt-2">Success!</div>}
        {submitError && <div className="row justify-content-center mt-2">Something went wrong... please email support@treatbot.gg</div>}
      </div>
    );
  };


  